import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Créatif",
  icon: "✨",
  templates: [
    {
      title: "Histoire du Soir",
      content: `Créez une histoire douce pour le coucher destinée à un jeune enfant, écrite pour être lue à voix haute.
- Le personnage principal est [un petit renard gentil] nommé [Noisette].
- L'histoire se déroule dans [un village forestier douillet où les lanternes brillent la nuit].
- Le personnage fait face à un petit défi apaisant : [elle ne trouve pas son étoile préférée dans le ciel nuageux, alors elle suit les lucioles jusqu'au sommet d'une colline].
- Terminez par une résolution paisible qui enseigne [la patience et la confiance que les bonnes choses sont toujours là, même quand on ne les voit pas].
- Utilisez des phrases courtes et rythmées qui sonnent naturellement à la lecture.`
    },
    {
      title: "Narration de Fiction Courte",
      content: `Écrivez une nouvelle adaptée à la narration de style livre audio.
- Genre : [mystère contemporain].
- Le protagoniste est [une bibliothécaire retraitée qui remarque quelque chose d'étrange dans la routine quotidienne du nouveau voisin].
- La tension centrale repose sur [de petits détails inexplicables qui s'accumulent vers une révélation surprenante mais satisfaisante].
- Ton : [suspense tranquille avec des touches de chaleur].
- Écrivez dans un style clair et fluide avec des longueurs de phrases variées pour maintenir l'engagement de l'auditeur.`
    },
    {
      title: "Lecture de Poésie",
      content: `Écrivez un poème destiné à être récité à voix haute.
- Sujet : [la sensation d'une ville qui s'éveille à l'aube].
- Style : [vers libre avec un rythme parlé naturel].
- Atmosphère : [réflexive et pleine d'espoir].
- Incluez des détails sensoriels vivants : [le bruit du premier bus, la lumière frappant le trottoir mouillé, l'odeur du pain frais d'une boulangerie].
- Utilisez des pauses et des retours à la ligne qui guident le rythme et la respiration du lecteur.`
    }
  ]
};
